import "./NextPreviousBtn.scss"
import React, { useState } from 'react'
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { ReactComponent as PrevIcon } from "./../../../assets/next-previous-btn/arrow-up.svg"
import { ReactComponent as NextIcon } from "./../../../assets/next-previous-btn/arrow-up.svg"
import classNames from "classnames"

const moveToRight = {
    x: 25,
    transition: { duration: .5 },
}
const moveToLeft = {
    x: -30,
    transition: { duration: .5 },
}

function NextPreviousBtn({ prevRoute, nextRoute, nextText, prevText, className, textClass ,barClass,navigateAction}) {

    const hideBar = prevRoute === '#' || nextRoute === '#'

    const [isHovered, setHovered] = useState(null)
    return (
        <div className={classNames("NextPreviousBtn overflow-hidden px-2", className)}>
            <motion.div
                whileHover={
                    isHovered === 'Previous' ? moveToRight : isHovered === "Next" ? moveToLeft : {}
                }
                className="flex justify-content-center align-items-center uppercase text-xs font-medium line-height-4"
            >
                <Link to={prevRoute} onClick={navigateAction!==null?navigateAction:()=>{}} className={classNames("no-underline ", { HideLink: prevRoute === "#" &&  navigateAction ==null })}>
                    <motion.div
                        onMouseEnter={() => setHovered("Previous")}
                        onMouseLeave={() => setHovered(null)}
                        className={classNames("Previous relative px-2 flex", textClass, { NoOpacity: isHovered === "Next" })}
                    >
                        <div>{prevText}</div>
                        <PrevIcon className="PrevIcon Icon absolute" />
                    </motion.div>
                </Link>
                <motion.div className={classNames("Bar",barClass, { HideBar: isHovered === "Previous" || isHovered === "Next" || hideBar })}></motion.div>
                <Link to={nextRoute} className={classNames("no-underline", { HideLink: nextRoute === "#" })}>
                    <motion.div
                        onMouseEnter={() => setHovered("Next")}
                        onMouseLeave={() => setHovered(null)}
                        className={classNames("Next relative px-2 flex", textClass, { NoOpacity: isHovered === "Previous" })}
                    >
                        <div>{nextText}</div>
                        <NextIcon className="NextIcon Icon absolute" />
                    </motion.div>
                </Link>
            </motion.div>
        </div>
    )
}

NextPreviousBtn.defaultProps = {
    prevRoute: "#",
    nextRoute: "#",
    nextText: "Next",
    prevText: "Previous",
    navigateAction:null
}

export default NextPreviousBtn